"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Provider = _interopRequireDefault(require("@react/react-spectrum/Provider"));

var _AppContext = _interopRequireDefault(require("../context/AppContext"));

require("@formatjs/intl-getcanonicallocales/polyfill");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var csTranslation = require('../../translation/cs.json');

var daTranslation = require('../../translation/da.json');

var deTranslation = require('../../translation/de.json');

var enTranslation = require('../../translation/en.json');

var esTranslation = require('../../translation/es.json');

var fiTranslation = require('../../translation/fi.json');

var frTranslation = require('../../translation/fr.json');

var huTranslation = require('../../translation/hu.json');

var itTranslation = require('../../translation/it.json');

var jaTranslation = require('../../translation/ja.json');

var koTranslation = require('../../translation/ko.json');

var nbTranslation = require('../../translation/nb.json');

var nlTranslation = require('../../translation/nl.json');

var plTranslation = require('../../translation/pl.json');

var ptTranslation = require('../../translation/pt.json');

var ruTranslation = require('../../translation/ru.json');

var svTranslation = require('../../translation/sv.json');

var trTranslation = require('../../translation/tr.json');

var ukTranslation = require('../../translation/uk.json');

var zhTranslation = require('../../translation/zh-Hans.json');

var zhHansTranslation = require('../../translation/zh-Hans.json');

var zhHantTranslation = require('../../translation/zh-Hant.json');

var zzTranslation = require('../../translation/zz.json');

var zzZZTranslation = require('../../translation/zz.json');

var zuTranslation = require('../../translation/zz.json');

var zuZUTranslation = require('../../translation/zz.json');

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');

  require('@formatjs/intl-pluralrules/dist/locale-data/cs');

  require('@formatjs/intl-pluralrules/dist/locale-data/da');

  require('@formatjs/intl-pluralrules/dist/locale-data/de');

  require('@formatjs/intl-pluralrules/dist/locale-data/en');

  require('@formatjs/intl-pluralrules/dist/locale-data/es');

  require('@formatjs/intl-pluralrules/dist/locale-data/fi');

  require('@formatjs/intl-pluralrules/dist/locale-data/fr');

  require('@formatjs/intl-pluralrules/dist/locale-data/hu');

  require('@formatjs/intl-pluralrules/dist/locale-data/it');

  require('@formatjs/intl-pluralrules/dist/locale-data/ja');

  require('@formatjs/intl-pluralrules/dist/locale-data/ko');

  require('@formatjs/intl-pluralrules/dist/locale-data/nb');

  require('@formatjs/intl-pluralrules/dist/locale-data/nl');

  require('@formatjs/intl-pluralrules/dist/locale-data/pl');

  require('@formatjs/intl-pluralrules/dist/locale-data/pt');

  require('@formatjs/intl-pluralrules/dist/locale-data/ru');

  require('@formatjs/intl-pluralrules/dist/locale-data/sv');

  require('@formatjs/intl-pluralrules/dist/locale-data/tr');

  require('@formatjs/intl-pluralrules/dist/locale-data/uk');

  require('@formatjs/intl-pluralrules/dist/locale-data/zh');
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/cs');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/da');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/de');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/en');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/es');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/fi');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/fr');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/hu');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/it');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/ja');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/ko');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/nb');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/nl');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/pl');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/pt');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/ru');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/sv');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/tr');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/uk');

  require('@formatjs/intl-relativetimeformat/dist/locale-data/zh');
}

var SPECTRUM_LOCALE_ALIAS = {
  cs: 'cs-CZ',
  da: 'da-DK',
  de: 'de-DE',
  en: 'en-US',
  es: 'es-ES',
  fi: 'fi-FI',
  fr: 'fr-FR',
  hu: 'hu-HU',
  // - not currently in spectrum
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  nb: 'nb-NO',
  nl: 'nl-NL',
  pl: 'pl-PL',
  pt: 'pt-BR',
  ru: 'ru-RU',
  sv: 'sv-SE',
  tr: 'tr-TR',
  uk: 'uk-UA',
  // - not currently in spectrum
  zh: 'zh-CN',
  zhhans: 'zh-CN',
  'zh-hans': 'zh-CN',
  'zh-hant': 'zh-TW',
  zhhant: 'zh-TW'
};
var stringSets = {
  cs: csTranslation,
  da: daTranslation,
  de: deTranslation,
  en: enTranslation,
  es: esTranslation,
  fi: fiTranslation,
  fr: frTranslation,
  hu: huTranslation,
  it: itTranslation,
  ja: jaTranslation,
  ko: koTranslation,
  nb: nbTranslation,
  nl: nlTranslation,
  pl: plTranslation,
  pt: ptTranslation,
  ru: ruTranslation,
  sv: svTranslation,
  tr: trTranslation,
  uk: ukTranslation,
  zh: zhTranslation,
  'zh-hans': zhHansTranslation,
  'zh-hant': zhHantTranslation,
  zz: zzTranslation,
  'zz-ZZ': zzZZTranslation,
  zu: zuTranslation,
  'zu-ZU': zuZUTranslation
};
/**
 * Wrapper component to add any required top-level components (i.e. react-intl provider)
 * @param {object} props - props sent to the component
 * @param {Array} props.children - list of children components
 * @param {string} [props.locale = 'en-US'] - current intl locale
 * @returns {ReactElement} markup
 */

var RootWrapper = function RootWrapper(props) {
  var _useContext = (0, _react.useContext)(_AppContext.default),
      typekitId = _useContext.typekitId,
      locale = _useContext.locale;

  var addSpectrum = props.addSpectrum,
      children = props.children,
      style = props.style,
      localeStringOverrides = props.localeStringOverrides;
  var formattedLocale = locale.toLowerCase();

  if (!stringSets[formattedLocale]) {
    formattedLocale = stringSets[formattedLocale.substring(0, 2)] ? formattedLocale.substring(0, 2) : 'en';
  }

  var _useContext2 = (0, _react.useContext)(_AppContext.default),
      theme = _useContext2.theme,
      spectrumUIScale = _useContext2.spectrumUIScale;

  var memoizedStyles = (0, _react.useMemo)(function () {
    return _objectSpread({
      height: '100%'
    }, style);
  }, [style]);
  var memoizedMessages = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, stringSets[formattedLocale]), localeStringOverrides[formattedLocale]);
  }, [localeStringOverrides, formattedLocale]);
  var contents = children;

  if (addSpectrum) {
    contents = /*#__PURE__*/_react.default.createElement(_Provider.default, {
      locale: SPECTRUM_LOCALE_ALIAS[formattedLocale],
      theme: theme,
      style: memoizedStyles,
      typekitId: typekitId,
      scale: spectrumUIScale
    }, contents);
  }

  return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    key: formattedLocale,
    locale: formattedLocale,
    messages: memoizedMessages
  }, contents);
};

RootWrapper.propTypes = {
  addSpectrum: _propTypes.default.bool,
  children: _propTypes.default.node,
  style: _propTypes.default.object,
  localeStringOverrides: _propTypes.default.object
};
RootWrapper.defaultProps = {
  addSpectrum: true,
  localeStringOverrides: {}
};
var _default = RootWrapper;
exports.default = _default;